<template>
  <el-dialog class="dialog" :visible.sync="privateShow" append-to-body>
    <img class="img" src="@/assets/images/course/xiajia@2x.png" />
    <div class="tip">该课程已下架，无法继续学习，如有问题请联系客服~</div>
    <template v-slot:footer>
      <el-button type="primary" @click="privateShow = false">知道了</el-button>
    </template>
    <img class="close" @click="privateShow = false" src="@/assets/images/course/close@2x.png" />
  </el-dialog>
</template>
<script>
export default {
  name: 'CourseSoldOutTip',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      privateShow: false,
    };
  },
  created() {
    this.privateShow = this.show;
  },
  watch: {
    privateShow() {
      this.$emit('update:show', this.privateShow);
    },
    show() {
      this.privateShow = this.show;
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog {
  ::v-deep {
    .el-dialog {
      width: 480px;
      height: 224px;
      text-align: center;
    }
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 23px 0 22px 0;
    }
    .el-dialog__footer {
      text-align: center;
      padding: 0 0 22px 0;
      .el-button {
        padding: 10px 41px;
      }
    }
  }
}
.img {
  width: 136px;
  height: 104px;
  vertical-align: middle;
}
.tip {
  font-size: 16px;
  color: rgba(26, 26, 26, 1);
  line-height: 1;
}
.close {
  position: absolute;
  width: 20px;
  top: 3px;
  right: -42px;
  cursor: pointer;
}
</style>
